"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line = exports.Bullet = exports.StepWrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var _wizard = require("./wizard.style");

var StepWrapper = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), _wizard.wizardStep);

exports.StepWrapper = StepWrapper;

var Bullet = _stylitas.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), _wizard.wizardBullet, _wizard.wizardBulletWithIcon, _wizard.wizardBulletSmall, _wizard.wizardBulletRegular, _wizard.wizardActive, _wizard.wizardSuccess, _wizard.wizardDisabled, _wizard.wizardBulletLarge, _wizard.wizardBulletCustom, _wizard.wizardBulletVertical);

exports.Bullet = Bullet;

var Line = _stylitas.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), _wizard.wizardLine, _wizard.wizardActive, _wizard.wizardSuccess, _wizard.wizardDisabled, _wizard.wizardLineVertical, _wizard.wizardLineCustom, _wizard.wizardLineLastStep);

exports.Line = Line;